export default "__VITE_ASSET__N8$QkzWY__"